import Capsule, { StudioCapsule } from "./Capsule";
import IconCheck from "ui/icons/IconCheck";
import IconWarning from "ui/icons/status/IconWarning";

## Basic Usage

<Capsule label="Default Capsule" />

---

## Sizes

<div style={{ display: "flex", alignItems: "center", gap: "1rem", flexWrap: "wrap" }}>
  <Capsule label="Large" size="large" />
  <Capsule label="Small X1" size="smallX1" />
  <Capsule label="Small" size="small" />
  <Capsule label="Mini" size="mini" />
</div>

---

## With Icons

<div style={{ display: "flex", alignItems: "center", gap: "1rem", flexWrap: "wrap" }}>
  <Capsule label="Approved" icon={<IconCheck size={12} />} />
  <Capsule label="Warning" icon={<IconWarning size={14} />} />
</div>

---

## Color Variants

<div style={{ display: "flex", alignItems: "center", gap: "0.5rem", flexWrap: "wrap" }}>
  <Capsule label="Default" />
  <Capsule label="Sapphire" color="sapphire" backgroundColor="sapphireLight" />
  <Capsule label="Emerald" color="emerald" backgroundColor="emeraldLight" />
  <Capsule label="Ruby" color="ruby" backgroundColor="rubyLight" />
  <Capsule label="Amber" color="amber" backgroundColor="amberLight" />
</div>

---

## StudioCapsule Variant

The StudioCapsule is a mini-sized capsule designed for compact UI contexts:

<div style={{ display: "flex", alignItems: "center", gap: "0.5rem", flexWrap: "wrap" }}>
  <StudioCapsule label="Status" />
  <StudioCapsule label="Tag" icon={<IconCheck size={10} />} />
</div>

---

## Use Cases

<div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
    <span>Project Status:</span>
    <Capsule label="In Progress" size="small" color="sapphire" backgroundColor="sapphireLight" />
  </div>
  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
    <span>Feature Tags:</span>
    <Capsule label="New" size="small" color="emerald" backgroundColor="emeraldLight" />
    <Capsule label="Beta" size="small" color="amber" backgroundColor="amberLight" />
  </div>
</div>


